<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
      	
		  <el-form :inline="true" class="backborder1" size="small" v-loading="query.loading">
		  	  <!-- 合作代理商 -->
		  	  <el-form-item style="width:13%" v-if="agentlists.length > 1">
      		  	  <el-select v-model="query.agentid" filterable @change="changeagents" placeholder="请选择合作代理商">
	              	  <el-option v-for="(item,index) in agentlists" :label="item.name" :value="item.id" :key="index"></el-option>
	              </el-select>
      		  </el-form-item>
			  <el-form-item style="width:15%" v-if="brandlists.length > 0">
	              <el-select v-model="query.brandid" clearable filterable  placeholder="请选择品牌" @change="query.ischange=true">
	                  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
	                	<span style="float: left">{{item.name}}</span>
      				    <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
	                  </el-option>
	              </el-select>
              </el-form-item>
			  <el-form-item style="width:13%">
      		  	  <el-select v-model="query.status" clearable filterable @change="query.ischange=true" placeholder="请选择商品状态">
	              	  <el-option v-for="(item,index) in statuslists" :label="item.name" :value="item.id" :key="index"></el-option>
	              </el-select>
      		  </el-form-item>
			  <el-form-item>
      		  	  <el-input type="text" v-model="query.key" placeholder="商品名称 / sku / 商品编号 / 条形码" clearable @keyup.enter.stop.native="getProductList" @change="query.ischange=true"/>
      		  </el-form-item>
			  <el-form-item>
				  <el-button type="primary" size="small" icon="el-icon-search" circle @click="getProductList"/>
      		  </el-form-item>
		  </el-form>

		  <div class="backborder2" style="margin-top:10px">
			<el-table :data="plists" v-loading="query.loading">
				<el-table-column label="id" align="left" prop="id" width="90"/>
				<el-table-column label="商品名称" align="left">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.name}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="规格" align="left" width="170" key="spec">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.spec}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="sku" align="center" v-if="query.agentid==100000" width="170" key="sku">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.number}}</span>
			        </template>
		        </el-table-column>
				<!--
				<el-table-column label="条形码" align="center" v-if="query.agentid < 100000" width="170" key="sku">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.barcode}}</span>
			        </template>
		        </el-table-column>
				-->
				<el-table-column label="京东销售价" align="center" v-if="query.agentid==100000" width="170" key="jdprice">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.jdprice}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="协议销售价" align="center" v-if="query.agentid==100000" width="170" key="price">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.price}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="编号" align="center" v-if="query.agentid < 100000" width="170" key="number">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.number}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="批发价" align="center" v-if="query.agentid < 100000" width="170" key="sell">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.sell}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="零售价" align="center" v-if="query.agentid < 100000" width="170" key="market">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.market}}</span>
			        </template>
		        </el-table-column>
				<el-table-column v-if="['9','11','12','14'].includes(version_id)" label="可用库存" align="center" width="170" key="market">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.available_inventory}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="状态" align="center" width="170" key="status">
			        <template slot-scope="scope">
			            <span style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.status==1 ? '已发布' : '未发布'}}</span>
			        </template>
		        </el-table-column>
				<el-table-column label="操作" align="center" width="170" key="handle">
			        <template slot-scope="scope">
			            <el-button type="danger" size="mini" icon="el-icon-plus" circle  v-if="scope.row.status==2" @click="getgoodsinfos(scope.row)"/>
			        </template>
		        </el-table-column>
			</el-table>
			<div class="block">
		        <!--分页begin-->
		        <el-pagination
		            @size-change="pageProductSizeChange"
		            @current-change="pageProductCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="productrows">
		        </el-pagination>
		        <!--分页end-->
	        </div>
		  </div>

		  

    </div>
    </transition>
</template>


<script>

import { quillEditor } from 'vue-quill-editor'
export default {
	props:['childdata'], 
    data(){
	    return{
			version_id: '',
	        actionauth:'', //功能权限
	        transitionshow:true,
	        url:this.GLOBAL.domain+"Goods/index",
	        agentlists:[],
			query: {
				act:'productlistsnews',
				token:this.$cookies.get('token'),
				loading:false,
				ischange:false,
				agentid:'',
				brandid:'',
				key:'',
				status:'',
				p:1,
				rollpage:10
			},
			plists:[],
			productrows:0,
			statuslists:[{id:1,name:'已发布'},{id:2,name:'未发布'}],
			brandlists:[],
			
	    }
	},

	watch: {
		childdata(val) {
			if(val.isgoodspush) { //触发商品信息获取详情
				alert("yes");
				this.getProductList();
			}
		},
	},

    
	mounted(){  
		var _this=this;
	    this.getactionauth();
		this.getpushagentlists(); //获取可发布商品的供应商
		this.version_id = localStorage.getItem('version_id');
	},
  
	methods:{
		
		/** 获取待发布的商品信息 **/
		getgoodsinfos(item) {
			this.$emit('listenchild',{name:'商品信息发布详情',url:'Goodspushinfo',data:{act:'savemallgoodsnew',agentid:this.query.agentid,goodspushinfo:true,data:item}});return false;
		},


		getProductList() {
			if(this.query.ischange) {this.query.p=1;this.query.rollpage=10;}
			this.query.loading=true;
			var resource = this.$resource(this.url);
	        resource.save(this.query).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.query.loading=false;
		        }else{
		            var result = JSON.parse(Base64.decode(res.data.Data));
					this.plists=result;
					this.productrows = parseInt(res.data.count);
					if(this.query.ischange) this.query.ischange=false;
					this.query.loading=false;
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
				this.query.loading=false;
	        });
		},

		pageProductSizeChange(val) {
	        this.query.rollpage = val;
	        this.getProductList();
	    },
	    pageProductCurrentChange(val) {
	        this.query.p = val;
	        this.getProductList();
	    },


		/** 切换代理商信息 **/
		changeagents() {
			this.getbrandinfos(this.query.agentid);
			this.query.brandid='';
			this.query.ischange=true;
			this.getProductList();
		},


		/** 获取代理商品牌信息 **/
		getbrandinfos(agentid) {
			var resource = this.$resource(this.url);
	        resource.save({act:'getagentbrands',agentid:agentid,token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
		},


		/** 获取可发布商品的供应商 **/
		getpushagentlists() {
			var resource = this.$resource(this.url);
	        resource.query({act:'getpushagentlists',token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.agentlists = JSON.parse(Base64.decode(res.data.Data));
					this.agentlists.forEach(function(item,index) {item.id=Number(item.id)});
					this.query.agentid=this.agentlists[0].id;
					this.getbrandinfos(this.query.agentid); //获取代理商品牌信息
					this.getProductList(); //获取商品信息
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
		},


		//重置表单
		reset() {
			this.$refs.create.resetFields();
		},
		    
		//获取功能权限
		getactionauth() {
			var data =this.$cookies.get('actionauth');
		    data=JSON.parse(data);
		    this.actionauth=data;
		},

		
	    
				        
    }
}
</script>

<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.add-goods-new {float:left;width:100%;}
.add-goods-new .el-form-item__label {font-size:13px}
.add-goods-left {float:left;width:25%;border-right:1px dashed #999999;min-height:200px;}
.add-goods-right {float:left;width:72%;min-height:200px}
.add-jdgoods-label {float:left;width:100%}
.add-jdgoods-label-info {float:left;line-height:23px;color:#fff;font-weight:500px;padding:5px 10px;border-radius:15px;background:#F56C6C;font-size:12px;margin-bottom:20px}
.add-jdgoods-label-notice {float:left;font-size:13px;line-height:23px;color:#F56C6C}
.add-goods-cover {float:left;width:100%;padding:0 0 20px 0}
.add-goods-cover span {float:left;margin-right:2%;font-size:13px;line-height:23px;margin-top:28.5px}
.add-goods-cover .add-goods-img-thumb {display:flex;justify-content:center;align-items:center;transition:.3s all;float:left;cursor:pointer;padding:3px;width:60px;height:60px;border-radius:15px;border:1px dashed #999999;background:rgba(221,221,221,.3);overflow:hidden}
.add-goods-cover .add-goods-img-thumb:hover {box-shadow:5px 5px 10px #666666}
.add-goods-cover .add-goods-img-thumb img {float:left;max-width:90%;max-height:90%;border-radius:6px}
.add-goods-img-lists {float:left;width:80%;}
.add-goods-cover .add-goods-img-thumb1 {display:flex;justify-content:center;align-items:center;transition:.3s all;float:left;cursor:pointer;padding:3px;width:60px;height:60px;border-radius:15px;border:1px dashed #999999;background:rgba(221,221,221,.3);overflow:hidden;margin:0 2% 10px 0}
.add-goods-cover .add-goods-img-thumb1:hover {box-shadow:5px 5px 10px #666666}
.add-goods-cover .add-goods-img-thumb1 img {float:left;max-width:90%;max-height:90%;border-radius:6px;width:''}
.add-goods-img-close {position:absolute;width:20px;height:20px;background:url(../../assets/error.png) no-repeat;background-size:20px 20px;margin:-60px 0 0 50px}
.add-goods-img-thumb1 .el-input {position:absolute;width:60px;margin-top:40px;background:rgba(0,0,0,.5);height:22px;border-radius:0 0 15px 15px}
.add-goods-img-thumb1 .el-input--mini .el-input__inner {background:none;border:none;font-weight:bold;color:#fff}
.add-goods-property-imgs {display:flex;justify-content:center;align-items:center;float:left;width:40px;height:40px;padding:5px;border-radius:6px;border:1px solid #dddddd;overflow:hidden;background:rgba(221,221,221,.3)}
.add-goods-property-imgs:hover {cursor:pointer;}
.add-goods-property-imgs img {max-width:90%;max-height:90%}
.add-goods-packing {float:left;width:100%}
.add-goods-packing .specs {float:left;width:100%;margin-top:40px;font-size:1em;}
.add-goods-packing .specs .tdTitle {float:left;font-size:13px;padding:10px 0}
</style>



// WEBPACK FOOTER //
// src/components/mall/Goodspushnew.vue